import React from 'react';
import contentMap from 'componentLibrary';
import {StyledElement as _StyledElement} from 'app-ui-componentlibrary/dist/componentLibrary/layout/StyledElement';

export const StyledElement = (props) => <_StyledElement {...{contentMap}} {...props} />;
export default StyledElement;
